import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table } from 'reactstrap';
import classnames from "classnames";
import SimpleAccountCard from '../../../../Components/General/Widgets/SimpleAccountCard';
import NormativeInfo from '../Widgets/NormativeInfo';
// import CommitmentCategoryInfo from '../Widgets/CommitmentCategoryInfo';
// import CommitmentComplianceStatusInfo from '../Widgets/CommitmentComplianceStatusInfo';
// import CommitmentComplianceMatrixInfo from '../Widgets/CommitmentComplianceMatrixInfo';
import UpcomingSchedules from '../Widgets/UpcomingSchedules';


const NormativeSection = () => {


    const tileBoxes4 = [
        {
            id: 2,
            icon: "ri-play-circle-fill",
            iconClass: "warning",
            opacity: "bg-opacity-25",
            label: "En operación",
            labelClass: "muted",
            counter: "45",
            caption: "",
            captionClass: "muted",
            percentage: "10.35 %",
            percentageClass: "danger",
            badge: "ri-arrow-down-s-line",
            decimals: 0,
            separator: ",",
            suffix: "",
            prefix: "",
        },
        {
            id: 3,
            icon: "bx bxs-badge-dollar",
            iconClass: "danger",
            opacity: "bg-opacity-25",
            label: "Total Revenue",
            labelClass: "muted",
            counter: "2845.05",
            caption: "From $1,750.04 last year",
            captionClass: "muted",
            percentage: "22.96 %",
            percentageClass: "success",
            badge: "ri-arrow-up-s-line",
            decimals: 2,
            separator: ",",
            suffix: "",
            prefix: "$",
        },
        {
            id: 3,
            icon: "bx bxs-badge-dollar",
            iconClass: "danger",
            opacity: "bg-opacity-25",
            label: "Total Revenue",
            labelClass: "muted",
            counter: "2845.05",
            caption: "From $1,750.04 last year",
            captionClass: "muted",
            percentage: "22.96 %",
            percentageClass: "success",
            badge: "ri-arrow-up-s-line",
            decimals: 2,
            separator: ",",
            suffix: "",
            prefix: "$",
        },
    ];



    return (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <Row>
                        {(tileBoxes4 || []).map((item, key) => (
                            <Col className='p-0'>
                                <SimpleAccountCard item={item} />
                            </Col>
                        ))}
                    </Row>
                </Col>
                <Col md={9}>
                    <Row>
                        {/* <Col md={4}>
                            <NormativeInfo id={'662988cb349f7afd12930fa6'} height={200} title={'Normativas por categoria'} subtitle={'Normativas'} legendPosition={'bottom'} with_total={false} />
                        </Col>
                        <Col md={4}>
                            <CommitmentCategoryInfo id={'662988cb349f7afd12930fa6'} height={200} title={'Compromisos por criticidad'} subtitle={'Compromisos'} legendPosition={'bottom'} with_total={false} />
                        </Col>
                        <Col md={4}>
                            <CommitmentComplianceStatusInfo id={'662988cb349f7afd12930fa6'} height={200} title={'Compromisos por cumplimiento'} subtitle={'Compromisos'} legendPosition={'bottom'} with_total={false} />
                        </Col> */}
                    </Row>
                </Col>
                <Col md={3}>
                    <Row>

                        <Col md={12}>
                            {/* <CommitmentComplianceMatrixInfo id={'662988cb349f7afd12930fa6'} title={'Criticidad vs Cumplimiento'} /> */}
                        </Col>
                        <Col md={12}>
                            <UpcomingSchedules />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default NormativeSection;